<template>
  <div class="memo-app">
    <div class="sidebarMemo">
      <div class="search-bar">
        <el-input v-model="query.searchQuery" clearable placeholder="搜索">
          <template #prefix>
            <Search style="width: 15px; height: 15px"/>
          </template>
        </el-input>
      </div>
      <div class="categories">
        <div class="category" :class="{ active: query.activeCategory === 'all' }" @click="setCategory('all')">
          <div class="categoryItem">
          <div class="ico" :class="{ active: query.activeCategory === 'all' }"/>
          <span>所有</span>
          </div>
          <span>{{ todoNum.allTodo }}</span>
        </div>
        <div class="category" :class="{ active: query.activeCategory === 'today' }" @click="setCategory('today')">
          <div class="categoryItem">
          <div class="ico" :class="{ active: query.activeCategory === 'today' }"/>
          <span>今天</span>
          </div>
          <span>{{ todoNum.todayTodo }}</span>
        </div>
        <div class="category" :class="{ active: query.activeCategory === 'recent' }" @click="setCategory('recent')">
          <div class="categoryItem">
          <div class="ico" :class="{ active: query.activeCategory === 'recent' }"/>
          <span>最近7天</span>
          </div>
          <span>{{ todoNum.recentTodo }}</span>
        </div>
        <div class="category" :class="{ active: query.activeCategory === 'done' }" @click="setCategory('done')">
          <div class="categoryItem">
            <div class="ico" :class="{ active: query.activeCategory === 'done' }"/>
            <span>已完成</span>
          </div>
          <span>{{  }}</span>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="header">
        <h1>{{ query.activeCategory === 'all' ? '所有' : query.activeCategory === 'today' ? '今天' : query.activeCategory === 'done' ? '已完成' : '最近7天' }}</h1>
      </div>
      <div class="todos custom-scrollbar" v-loading="todoLoading">
        <div v-for="(todo, index) in filterTodos" :key="index" :class="{ topStyle: todo.is_top}" style="flex-direction: column" class="todo-item">
          <div style="display: flex;flex-direction: row;width: 100%;align-items: center;">
          <div class="opt" :class="{ active: todo.is_done}" @click="updateTodo(todo)">
            <Check style="color: white;" v-show="todo.is_done"/>
          </div>
          <el-input class="textArea" :class="{ done: todo.is_done}" @change="updateContent(todo)" v-model="todo.content" autosize type="textarea"/>
          <el-date-picker style="width: 125px;margin: 0px 2px;" class="todo-day" v-model="todo.todo_date" @change="updateContent(todo)" value-format="YYYY-MM-DD" placeholder="日期" type="date" size="small"/>
            <el-popover trigger="hover">
              <template #reference>
                <More style="width: 18px"></More>
              </template>
              <div style="display: flex;flex-direction: row; justify-content: space-around">
                <el-tooltip content="置顶">
                <CaretTop @click="setTop(todo)" v-show="!todo.is_top" class="deleteIco"/>
                </el-tooltip>
                <el-tooltip content="取消置顶">
                <CaretBottom @click="setTop(todo)" v-show="todo.is_top" class="deleteIco"/>
                </el-tooltip>
                <el-tooltip content="删除">
                <Delete @click="deleteTodo(todo)" class="deleteIco" />
                </el-tooltip>
                <el-tooltip content="展开">
                <CirclePlusFilled v-show="!todo.showSon" class="deleteIco" @click="showSon(todo)"/>
                </el-tooltip>
                <el-tooltip content="收起">
                <RemoveFilled v-show="todo.showSon" class="deleteIco" @click="todo.showSon = !todo.showSon"/>
                </el-tooltip>
              </div>
            </el-popover>
          </div>
          <div v-show="todo.showSon" v-for="(todoSon, index) in todo.todoSons" :key="index" :class="{ topStyle: todoSon.is_top}" style="width: 90%;border: none;background-color: transparent;margin-bottom: 0px" class="todo-item">
              <div style="width: 18px;height: 18px" class="opt" :class="{ active: todoSon.is_done}" @click="updateTodo(todoSon)">
                <Check style="color: white;" v-show="todoSon.is_done"/>
              </div>
              <el-input class="textArea" :class="{ done: todoSon.is_done}" @change="updateContent(todoSon)" v-model="todoSon.content" autosize type="textarea"/>
              <el-date-picker style="width: 125px;margin: 0px 2px;" class="todo-day" v-model="todoSon.todo_date" @change="updateContent(todoSon)" value-format="YYYY-MM-DD" placeholder="日期" type="date" size="small"/>
<!--            <el-popover trigger="hover">
              <template #reference>
                <More style="width: 16px"></More>
              </template>
              <div style="display: flex;flex-direction: row; justify-content: space-around">
                <el-tooltip content="删除">
                <Delete style="width: 16px;height: 16px" @click="deleteTodo(todoSon)" class="deleteIco" />
                </el-tooltip>
              </div>
            </el-popover>-->
            <Delete style="width: 16px;height: 16px" @click="deleteTodoSon(todo,todoSon)" class="deleteIco" />
          </div>
          <div v-show="todo.showSon" class="input-bar" style="width: 100%">
            <el-input style="height: 35px" v-model="newTodoSonText" placeholder="新增待办子项" clearable :prefix-icon="Search" @keyup.enter="addTodoSon(todo)">
              <template #prefix>
                <Plus style="width: 15px; height: 15px"/>
              </template>
              <template #suffix>
                <svg t="1719219345887" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4238" data-darkreader-inline-fill="" width="15" height="15"><path d="M810.666667 213.333333a42.666667 42.666667 0 0 1 42.368 37.674667L853.333333 256v274.304c0 79.274667-50.944 147.498667-120.490666 152.106667L725.333333 682.666667H273.706667l97.792 97.834666a42.666667 42.666667 0 0 1-56.32 63.872l-4.010667-3.541333-170.666667-170.666667a42.666667 42.666667 0 0 1 0-60.330666l170.666667-170.666667a42.666667 42.666667 0 0 1 63.872 56.32l-3.541333 4.010667L273.706667 597.333333H725.333333c19.584 0 39.936-24.618667 42.410667-59.861333l0.256-7.168V256a42.666667 42.666667 0 0 1 42.666667-42.666667z" fill="#000000" p-id="4239" data-darkreader-inline-fill="" style="--darkreader-inline-fill: #000000;"></path></svg>
              </template>
            </el-input>
          </div>
        </div>
      </div>
      <div class="input-bar">
        <el-input style="height: 40px" v-model="newTodoText" placeholder="新增待办" clearable :prefix-icon="Search" @keyup.enter="addTodo">
          <template #prefix>
            <Plus style="width: 15px; height: 15px"/>
          </template>
          <template #suffix>
            <svg t="1719219345887" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4238" data-darkreader-inline-fill="" width="15" height="15"><path d="M810.666667 213.333333a42.666667 42.666667 0 0 1 42.368 37.674667L853.333333 256v274.304c0 79.274667-50.944 147.498667-120.490666 152.106667L725.333333 682.666667H273.706667l97.792 97.834666a42.666667 42.666667 0 0 1-56.32 63.872l-4.010667-3.541333-170.666667-170.666667a42.666667 42.666667 0 0 1 0-60.330666l170.666667-170.666667a42.666667 42.666667 0 0 1 63.872 56.32l-3.541333 4.010667L273.706667 597.333333H725.333333c19.584 0 39.936-24.618667 42.410667-59.861333l0.256-7.168V256a42.666667 42.666667 0 0 1 42.666667-42.666667z" fill="#000000" p-id="4239" data-darkreader-inline-fill="" style="--darkreader-inline-fill: #000000;"></path></svg>
          </template>
        </el-input>
      </div>
    </div>
  </div>
</template>

<script>
import {Delete,Check,Search,Plus,CaretTop,CaretBottom,CirclePlusFilled,RemoveFilled,More} from "@element-plus/icons-vue";
export default {
  components: {Delete,Check,Search,Plus,CaretTop,CaretBottom,CirclePlusFilled,RemoveFilled,More},
  data() {
    return {
      query: {
        searchQuery: '',
        activeCategory: 'all',
      },
      todoNum:{
        allTodo:0,
        todayTodo:0,
        recentTodo:0,
      },
      newTodoText: '',
      newTodoSonText: '',
      todos: [],
      todoLoading:false
    };
  },
  computed: {
    filterTodos(){
      let filterTodos = this.todos
      if (this.query.searchQuery){
        filterTodos = filterTodos.filter(todo => todo.content.toLowerCase().includes(this.query.searchQuery.toLowerCase()));
      }
      return filterTodos
    }
  },
  created() {
    this.getMemo()
  },
  methods: {
    setCategory(category) {
      this.query.activeCategory = category;
      this.getMemo()
    },

    showSon(res){
      res.showSon = !res.showSon
      this.getMemoSon(res)
    },

    addTodo() {
      if (this.newTodoText.trim()) {
        let todo = {
          content: this.newTodoText
        }
        this.$http('oaMemoService.addMemo', todo).then(() => {
          this.$message.success("添加待办成功!");
          this.getMemo()
        })
        this.newTodoText = '';
      }
    },

    addTodoSon(res) {
      if (this.newTodoSonText.trim()) {
        let todoSon = {
          content: this.newTodoSonText,
          parent_id:res.id
        }
        this.$http('oaMemoService.addMemo', todoSon).then(() => {
          this.$message.success("添加待办子项成功!");
          this.getMemoSon(res)
        })
        this.newTodoSonText = '';
      }
    },

    async getTodoNum(){
      let data = await this.$http('oaMemoService.getAllTodoNum')
      this.todoNum = data
    },

    async getMemo(){
      this.todoLoading = true
      this.todos = await this.$http('oaMemoService.getMemo',this.query)
      await this.getTodoNum()
      this.todoLoading = false
    },

    async getMemoSon(res){
      res.todoSons = await this.$http('oaMemoService.getMemoSon',res)
    },

    async deleteTodo(res){
      await this.$http('oaMemoService.deleteTodo',res)
      this.getMemo()
    },

    async deleteTodoSon(res1,res2){
      await this.$http('oaMemoService.deleteTodo',res2)
      await this.getMemoSon(res1)
    },

    async updateContent(res){
      await this.$http('oaMemoService.updateTodo',res)
      if (!res.parent_id) {
        await this.getMemo()
      }
    },

    async setTop(res){
      res.is_top = !res.is_top
      await this.updateContent(res)
    },

    async updateTodo(res){
      res.is_done = !res.is_done
      await this.updateContent(res)
    }
  }
};
</script>

<style scoped>
.memo-app {
  display: flex;
  height: 100vh;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.sidebarMemo {
  width: 30%;
  background-color: whitesmoke;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #ddd;
  overflow: hidden;
}

.search-bar {
  padding: 10px;
}

.search-bar input {
  width: 100%;
  padding: 10px;
  border: none;
  border-radius: 20px;
  background-color: #e0e0e0;
  outline: none;
}

.categories {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.todo-item.topStyle{
  border: 2px solid #ababab;
  background-color: #f0f4f8;
}

.ico{
  width: 5px;
  height: 100%;
  margin-right: 5px;
}

.ico.active{
  background: rgb(24 144 255);
  border-radius: 10px;
}

.category {
  padding: 15px;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  transition: background-color 0.3s;
  border-radius: 15px;
  margin: 0px 10px;
}

.categoryItem{
  display: flex;
}

.category.active {
  background-color: #1890ff1a;
}

.new-todo {
  padding: 15px;
  text-align: center;
  cursor: pointer;
  border-top: 1px solid #ddd;
  transition: background-color 0.3s;
}

.new-todo:hover {
  background-color: #e0e0e0;
}

.main {
  width: 70%;
  display: flex;
  flex-direction: column;
  border-radius: 0 10px 10px 0;
  overflow: hidden;
  box-shadow: -5px 0 10px rgba(0, 0, 0, 0.1);
}

.header {
  padding: 10px;
}

.header h1 {
  margin: 0;
  font-size: 24px;
}

.opt{
  width: 20px;
  height: 20px;
  border: 2px solid #ababab;
  border-radius: 5px;
  cursor: pointer;
}

.opt:hover{
  border-color: #40a9ff;
}

.opt.active{
  background-color: #40a9ff;
  border-color: #40a9ff;
}

.deleteIco{
  width: 18px;
  height: 18px;
  cursor: pointer
}

.deleteIco:hover{
  color: #40a9ff;
}

.el-date-table td.past-date {
  color: red;
}

.todos {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
}

.todo-item {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border: 1px solid #ddd;
  background-color: whitesmoke;
  margin-bottom: 5px;
  border-radius: 10px;
}

. todo-item:hover {
  background-color: #f5f5f5;
}

.textArea{
  width: 75%;
  color: black;
}

.textArea.done{
  text-decoration: line-through;
  color: #ababab;
}

.textArea.done>>>.el-textarea__inner{
  color: #ccc;
}

/deep/.el-textarea{
  border: none;
}

/deep/.el-textarea__inner{
  background-color: transparent;
  box-shadow: none;
  resize: inherit;
}

>>>.el-input__wrapper {
  border-radius: 10px;
}

>>>.el-input__wrapper.is-focus {
  color: #40a9ff;
}

.input-bar {
  padding: 10px;
}

.input-bar input {
  width: 100%;
  padding: 10px;
  border: none;
  border-radius: 20px;
  background-color: #e0e0e0;
  outline: none;
}

>>>.el-input--small .el-input__wrapper{
  background-color: transparent;
  box-shadow: none;
}

/* 修改特定元素的滚动条 */
.custom-scrollbar {
  overflow-y: scroll;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 8px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: #e1e1e1;
  border-radius: 4px;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #999;
  border-radius: 4px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #666;
}
</style>